import ContainerFlex from '~/components/containerFlex';

export const Header = ({ label }) => {
  return (
    <ContainerFlex
      flex={1}
      horizontal
      center
      align="flex-start"
      style={{
        maxHeight: '40px',
        minHeight: '40px',

        backgroundColor: '#af0b2b',
        borderRadius: '8px 8px 0px 0px',
      }}
    >
      <span
        style={{
          color: 'white',
          fontSize: 16,
          marginLeft: 8,
          textAlign: 'center',
          fontWeight: 600,
        }}
      >
        {label}
      </span>
    </ContainerFlex>
  );
};
